import { CustomerIcon } from "@/components/RFIcon";
import { useContactUsContext } from "@/provider/ContactUsContext";

export default function BrowserCustomer() {
	const { onShowContactUs } = useContactUsContext();

	const handleOpenCustomService = () => {
		onShowContactUs?.();
	};

	return (
		<div
			className="inline-flex w-[2.125rem] h-[2.125rem] rounded-full dark:bg-black_1a bg-smallBg items-center justify-center cursor-pointer"
			onClick={handleOpenCustomService}
		>
			<CustomerIcon className="w-[17px] h-[17px]" />
		</div>
	);
}
